import { IOnoffable, PoolDeviceInterface } from "../Interfaces";
import { DisplayProcessingLogics, StatesToDisplayItem, PoolDeviceCriticalDesiredActual } from "../Types";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";
import PoolDeviceOnOffable from "./base-onoffable";


export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDeviceFlowMeter extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable {
    static minAutoFilterVersion = 23;
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.FLOWMETER;
    static Icon = "gauge-on-pipe";
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("Flow Meter");

    getDisplayNameTranslated(displayName:string) {
        switch (displayName) {
        case "Flow Rate": return Locale.gettext("Flow Rate");
        case "Rate": return Locale.gettext("Rate");
        default: return super.getDisplayNameTranslated(displayName);
        }
    }

    getMainMetricField(): StatesToDisplayItem {
        let order = 0;
        return {
            Name: PoolsideDaemonDeviceStateNames.FlowRateGPM,
            DisplayName: "Flow Rate",
            DisplayNameShort: "Rate",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.GPM,
            DisplayProcessingLogicUnitAsDisplayName: false,
        }
    }

    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    FlowRateGPM = "FlowRateGPM",
    PowerState = "PowerState",
}
